/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

interface OwnProps {
    title: string;
    orderNumber: string;
}

type Props = OwnProps;

const WorkOrderDetailPageTypeLink: React.FunctionComponent<Props> = ({ title, orderNumber }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: "WorkOrderDetailsPage",
            overrideTitle: title,
            queryString: `orderNumber=${orderNumber}`,
        },
    });
};

export default WorkOrderDetailPageTypeLink;
